import HeroHeading from './HeroHeading';

export default HeroHeading;
